export default __webpack_public_path__ + "static/media/image-dashboardSections-2000x3000-png.f2e365ae.png";